import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCEa1YEl4w7dBG-idvsJXEehDPdO4SbrrA",
  authDomain: "ftps-bf9ce.firebaseapp.com",
  projectId: "ftps-bf9ce",
  storageBucket: "ftps-bf9ce.firebasestorage.app",
  messagingSenderId: "11550192572",
  appId: "1:11550192572:web:434fbf5f4d8dd84937b1b9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
